export interface CheckoutSuccessfulContract {
  offerReference: string;
  contractId: string;
  itemId: string;
}
